export default __webpack_public_path__ + "static/media/ic-error-modal.31a64843.svg";